import React from "react";
import { renderLayout } from "schema/ThemeSet.react";
import TitleBlock from "slides/components/TitleBlock.react";

export default class Title extends React.Component {
    render() {
        let isPortrait =
            this.props.mobileView || window.innerHeight > window.innerWidth;
        let LayoutRender = renderLayout(isPortrait, this.props.layout);

        return (
            <div className="full-height">
                <LayoutRender
                    {...this.props}
                    background={this.props.data.background}
                    mainContent={<TitleBlock {...this.props} />}
                />
            </div>
        );
    }
}
